import {
    ReactElement,
    HTMLAttributes
} from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    title: string;
    isActive?:boolean;
    onClick?:any;
}

export function PolicyCategoryCard({ title , isActive , onClick}: Props): ReactElement {
    return (
        <div className={`${isActive ? " policy-category-card-active" : ""} policy-category-card`} onClick={onClick}>
                {title}
        </div>
    )
}
export default PolicyCategoryCard;